import styles from 'legacy/common/components/form/Form.module.scss';

import { useState } from 'react';
import classnames from 'classnames';
import ReactCodeInput from 'react-verification-code-input';

import { handleLogin } from 'legacy/auth/helpers';
import {
  usePhoneLoginRequestCommand,
  usePhoneRegisterCommand
} from 'legacy/auth/hooks';

import Button, { ButtonType } from 'legacy/common/components/button/Button';

type PhoneRegisterConfirmationProps = {
  phoneNumber: string;
};

const PhoneRegisterConfirmation: React.FC<PhoneRegisterConfirmationProps> = ({
  phoneNumber
}) => {
  const [code, setCode] = useState('');

  const {
    mutate: resendVerificationCommand,
    error: resendError,
    isLoading: isLoadingResend
  } = usePhoneLoginRequestCommand();

  const {
    mutate: phoneRegisterCommand,
    error: phoneRegisterError,
    isLoading: isLoadingPhoneRegister
  } = usePhoneRegisterCommand();

  const onSubmit = (code: string, phone: string) => {
    phoneRegisterCommand(
      {
        code,
        phone
      },
      {
        onSuccess: (data) => {
          handleLogin(data);
        }
      }
    );
  };

  return (
    <>
      <div className={styles.group}>
        <p className={styles.submitError}>
          {phoneRegisterError?.message || resendError?.message}
        </p>
      </div>
      <div className={styles.group}>
        <p className={classnames(styles.label, styles.small)}>
          Verification Code
        </p>
        <div className={`${styles.codeInputContainer} font-family-inter!`}>
          <ReactCodeInput
            fields={4}
            fieldWidth={45}
            fieldHeight={60}
            onComplete={(val) => {
              onSubmit(val, phoneNumber);
              setCode(val);
            }}
            className={styles.codeInput}
            placeholder={['#', '#', '#', '#']}
          />
        </div>
      </div>
      <div className={styles.FormGroup}>
        <Button
          disabled={!code}
          loading={isLoadingPhoneRegister}
          type={ButtonType.Primary}
          onClick={() => {
            onSubmit(code, phoneNumber);
          }}
        >
          Confirm Code
        </Button>
      </div>
      <div className={styles.group}>
        {isLoadingResend ? (
          'Sending Again...'
        ) : (
          <>
            {"Didn't receive? "}
            <span
              className={styles.actionItem}
              onClick={() => {
                resendVerificationCommand(phoneNumber);
              }}
            >
              Send Again
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default PhoneRegisterConfirmation;
